// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f9e21e75","365":"a716210f","366":"e6feed26","501":"aee2c03c"}[chunkId] + ".chunk.js";
};